/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

// ---------------------------------------------
// HEY, USING HUD IN THIS WAY IS PROBABLY WRONG
// the sane thing would probably be to update the world in pixi, then use that to update the HUD
// instead of updating the hud from pixi events, then listening to the hud to update the world
// ---------------------------------------------
import { DisplayObject } from 'pixi.js-legacy';

import { Component } from '@appCanvasCommon/component-system/Component';
import { ComponentInterface } from '@appCanvasCommon/interfaces/component.interface';
import Point from '@appLegacy/lib/math/Point';
import { EventBinder } from '../interaction-utils';
import { CanvasAngularLand } from 'src/app/app-data/interfaces/canvas-angular-land';
import { CONTEXT_MENUS } from 'src/app/modules/ticket-edit/context-menu.service';

export class PlanDrag extends Component implements ComponentInterface {
	private _binder: EventBinder;
	constructor() {
		super();
	}
	/**
	 * The setup method is called once all properties on a component have been decorated by the ComponentManager.
	 *
	 * From this point on, you can safely use this.getParent() and this.getManager().
	 *
	 * Arguments passed into setup are passed in via the ComponentManager.add(name, component, ...args)
	 */
	public override setup(canvasAngularLand: CanvasAngularLand, parent: DisplayObject): void {
		this.canvasAngularLand = canvasAngularLand;
		this._binder = new EventBinder(parent);
		const hud = canvasAngularLand.hud;
		//supportedEvents.push('simpledragstart', 'simpledrag', 'simpledragend');
		this._binder.add('hammer-panstart', (event) => {
			hud.onStartTranslate();
			canvasAngularLand.contextMenuService.hide(CONTEXT_MENUS.TICKET_QUICK_STATUS);
			canvasAngularLand.contextMenuService.hide(CONTEXT_MENUS.TICKET_EDIT_CONFIRM_MENU);
			canvasAngularLand.timelineTicketService.closeOverflow();
		});
		this._binder.add('hammer-pan', (event) => {
			hud.onTranslate(new Point(event.deltaX, event.deltaY));
		});
		this._binder.add('hammer-panend', (event) => {
			hud.onEndTranslate();
		});
	}

	/**
	 * ...must...kill...stuff....here
	 */
	public override destroy() {
		super.destroy();
		this._binder.destroy();
	}
}
